import style from './footerCompoStyle.module.css';
import { Tooltip } from '@mantine/core';
import { Link } from 'react-router-dom';
import emailIcon from '../../assets/images/Icons/email-icon.svg';
import whatsappIcon from '../../assets/images/Icons/whatsapp-icon.svg';
import youtube from '../../assets/images/Icons/icon-sosmed/youtube-icon.svg';
import instagram from '../../assets/images/Icons/icon-sosmed/instagram-icon.svg';
import facebook from '../../assets/images/Icons/icon-sosmed/facebook-icon.svg';
import tiktok from '../../assets/images/Icons/icon-sosmed/tiktok-icon.svg';
import Swal from 'sweetalert2';
const FooterCompo = () => {
  const comingSoon = () => {
    Swal.fire({
      title: 'Info',
      text: 'Segara hadir',
      icon: 'info',
      timer: 2000,
    });
  };

  const notFound = () => {
    Swal.fire({
      title: 'Info',
      text: 'Halaman belum tersedia',
      icon: 'info',
      timer: 2000,
    });
  };

  return (
    <div>
      <footer className={`${style.kontak}`}>
        <div
          className={`${style['container-fluid']} container-fluid text-center`}
        >
          <div className={`${style.awal} row text-center mb-0`}>
            <div className="col-lg-3">
              <div className={`${style['icon-logo']} col`}>
                <a
                  href="https://www.youtube.com/channel/UChSicdrwHc5api6jWRCICCQ"
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={youtube} alt="" />
                </a>
                <a
                  href="https://www.instagram.com/sepakat.properti/"
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={instagram} alt="" />
                </a>
                <a
                  href="https://www.tiktok.com/@sepakat.properti"
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={tiktok} alt="" />
                </a>
                <a
                  href="https://www.facebook.com/sepakat.properti"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={facebook} alt="" />
                </a>
                <div className="row mt-4">
                  <div className={`col d-flex flex-row ${style['icon-logo2']}`}>
                    <img
                      src={require('../../assets/images/Section-Footer-Logo Putih 1.png')}
                      alt=""
                      className="me-3"
                    />
                    <h1 className={`${style.logoFooter} m-0`}>Sepakat</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="col mx-auto text-start">
              <Link to="/syarat-ketentuan">
                <p className="mb-3">Syarat & Ketentuan</p>
              </Link>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScGW8JuTWLuq9A3SW6s83GB3OS5tuntuqsEk9NUjk9wM0uLgA/viewform?usp=sf_link"
                target="_blank"
                rel="noreferrer"
              >
                <p>Menjadi Agen</p>
              </a>
              <a href="/konten-video">
                <p className="mb-3">Edukasi Properti</p>
              </a>
              <a href="/#" onClick={notFound}>
                <p>Karir</p>
              </a>
            </div>
            <div className="col mx-auto text-start">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfBkuEsfLr4PWUHX8CrFS-zxX0s2Iby_cTccA5NN6umFtgqIg/viewform?usp=sf_link">
                <p className="mb-3">Kritik & Saran</p>
              </a>
              <a
                href="https://api.whatsapp.com/send/?phone=6281335258080&text=Halo,+saya+mengalami+kendala+dengan+aplikasi+sepakat.+Apakah+bisa+dibantu?&type=phone_number&app_absent=0"
                target="_blank"
                rel="noreferrer"
              >
                <p className="mb-3">Bantuan Pengguna</p>
              </a>

              <Link to="/kebijakan-privasi">
                <p className="mb-3">Kebijakan dan Privasi</p>
              </Link>

              <div onClick={notFound}>
                <p>Hak Cipta</p>
              </div>
            </div>
            <div className="col mx-auto text-start">
              <Tooltip label="Segera Hadir" color="green.9">
                <div onClick={comingSoon}>
                  <p>Kalkulator KPR</p>
                </div>
              </Tooltip>
              <a
                href="https://api.whatsapp.com/send/?phone=6281335258080&text=Halo,+saya+ingin+mengetahui+lebih+lanjut+perihal+sepakat,+apakah+bisa+dibantu?&type=phone_number&app_absent=0"
                target="_blank"
                rel="noreferrer"
              >
                <p className="mb-3">Customer Service</p>
              </a>
            </div>
            <div className={`${style.contact} col mx-auto text-start`}>
              <h1>Informasi lebih hubungi</h1>
              <div
                className={`${style.container} ${style['kolom-1']}  d-flex flex-row`}
              >
                <div className={`${style['klm-1']} col d-flex mt-2`}>
                  <img
                    className="mt-1 ms-3"
                    src={emailIcon}
                    alt=""
                    width="15px"
                    height="15px"
                  />
                  <p className={`ms-2 me-3 ${style.email}`}>
                    ptsepakatmenjalaberkat@gmail.com
                  </p>
                </div>
              </div>
              <div
                className={`${style.container} ${style['kolom-2']}  d-flex flex-row`}
              >
                <div className={`${style['klm-2']}col d-flex mt-2`}>
                  <img
                    className="mt-1 ms-3"
                    src={whatsappIcon}
                    alt=""
                    width="15px"
                    height="15px"
                  />
                  <p className="ms-2 me-3">0813 3525 8181</p>
                </div>
              </div>
            </div>
          </div>
          <div className={`${style.barBottom} row`}>
            <div
              className={`${style.bottomBar} col mx-auto text-start bg-success`}
            >
              <h1 className="text-start">2022 Copyright Sepakat</h1>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterCompo;
